<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "AppMain",
  
})
</script>
<template>
  <!-- :class="routeType == 2 ? 'mains' : routeType == 1 ? 'app-main' : 'mains'" -->
  <section
    :key="mainKey"
    ref="appMain"
    :class="routeType == 3 ? 'app-main' : 'mains'"
    @scroll="handleParentScroll"
  >
    <router-view v-slot="{ Component, route: currentRoute }">
      <transition
        :enter-active-class="animate"
        mode="out-in"
      >
        <keep-alive :include="tagsViewStore.cachedViews">
          <component
            :is="Component"
            v-if="!currentRoute.meta.link"
            :key="currentRoute.path"
          />
        </keep-alive>
      </transition>
    </router-view>
    <iframe-toggle />
  </section>
</template>

<script setup name="AppMain" lang="ts">
import { useSettingsStore } from '@/store/modules/settings';
import { useTagsViewStore } from '@/store/modules/tagsView';
import eventBus from '@/utils/eventBus';

import IframeToggle from './IframeToggle/index.vue';
const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const route = useRoute();
const appMain = ref(null);
const mainKey = ref(1);
const tagsViewStore = useTagsViewStore();
const routeType = ref(1); // 1：默认白色白色背景  2：首页   3：空背景
// 空背景的路由
const routeList = ref(['/storeOperations/productManage/productArchive/classfication']);

// 随机动画集合
const animate = ref<string>('');

const animationEnable = ref(useSettingsStore().animationEnable);
watch(
  () => tagsViewStore.isMainType,
  (val: any) => {
    routeType.value = val;
  },
  { immediate: true },
);

watch(
  () => route.path,
  (val: any) => {
    // 根据当前路由确定主内容区域类型
    let mainType = 1;
    if (routeList.value.includes(val)) {
      mainType = 3;
    } else if (val == '/index') {
      mainType = 2;
    }
    tagsViewStore.isMain(mainType);
  },
  { immediate: true },
);

watch(
  () => useSettingsStore().animationEnable,
  (val: boolean) => {
    animationEnable.value = val;
    if (val) {
      animate.value = proxy?.animate.animateList[Math.round(Math.random() * proxy?.animate.animateList.length)] as string;
    } else {
      animate.value = proxy?.animate.defaultAnimate as string;
    }
  },
  { immediate: true },
);

onMounted(() => {
  addIframe();
  appMain.value.scrollTop = 0;
  setTimeout(() => {}, 1000);
  // eventBus.on('table-scroll', tableScroll);
});

watchEffect(() => {
  addIframe();
});

// function tableScroll(top) {
//   appMain.value.scrollTop = top
// }

function addIframe() {
  if (route.meta.link) {
    useTagsViewStore().addIframeView(route);
  }
}
function handleParentScroll() {
  eventBus.emit<number>('parent-scroll', appMain.value.scrollTop);
}
// 5. 组件卸载时，清理事件监听
onUnmounted(() => {
  // 移除 eventBus 监听
  eventBus.off<number>('parent-scroll', handleParentScroll);
});
</script>

<style lang="scss" scoped>
.mains {
  width: 100%;
  height: calc(100vh - 120px);
  margin-top: 5px;
  border-radius: 10px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;

  /* 隐藏 WebKit 浏览器（Chrome、Safari）的滚动条 */
  &::-webkit-scrollbar {
    width: 0;
    /* 纵向滚动条宽度设为 0 */
    height: 0;
    /* 横向滚动条高度设为 0 */
  }
}

.padd {
  padding: 0 !important;
}

.app-main {
  /* 50= navbar  50  */
  width: 100%;
  height: calc(100vh - 120px);
  margin-top: 5px;
  border-radius: 10px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;

  /* 隐藏 WebKit 浏览器（Chrome、Safari）的滚动条 */
  &::-webkit-scrollbar {
    width: 0;
    /* 纵向滚动条宽度设为 0 */
    height: 0;
    /* 横向滚动条高度设为 0 */
  }
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    // min-height: calc(100vh - 84px);
  }
}
</style>
<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-inline-end: 6px;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
</style>
